import { Attribute } from "../Types/Attribute";

export async function fetchNormalizedByInserts(attributeName: string) {
    const apiUrl = process.env.REACT_APP_API_URL;
    let url = `${apiUrl}/teams/factory/normalized/inserts?attributename=${attributeName}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });

        if (response.ok) {
            const attributes: Attribute[] = await response.json();
            return attributes;
        } else {
            return Promise.reject("Failed to fetch attributes");
        }
    } catch (error) {
        console.error(error);
    }
}

export async function fetchNormalizedByOrders(attributeName: string) {
    const apiUrl = process.env.REACT_APP_API_URL;
    let url = `${apiUrl}/teams/factory/normalized/order?attributename=${attributeName}`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });

        if (response.ok) {
            const attributes: Attribute[] = await response.json();
            return attributes;
        } else {
            return Promise.reject("Failed to fetch attributes");
        }
    } catch (error) {
        console.error(error);
    }
}

export async function fetchTotalPowerConsumption() {
    const apiUrl = process.env.REACT_APP_API_URL;
    let url = `${apiUrl}/teams/factory/power`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });

        if (response.ok) {
            const attributes: Attribute[] = await response.json();
            return attributes;
        } else {
            return Promise.reject("Failed to fetch attributes");
        }
    } catch (error) {
        console.error(error);
    }
}